import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    let enArr = ['zh-CN','zh-SG','zh-TW','zh-HK'];
    let defaultLang = 'CN';
    try {
        if(!enArr.includes(navigator.language)){
            defaultLang = 'EN';
        }
    } catch (error) {
        console.log(error);
    }
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('language') || defaultLang;
    });

    const toggleLanguage = () => {
        setLanguage(prev => {
            let nextLang = prev === 'CN' ? 'EN' : 'CN';
            localStorage.setItem('language', nextLang);
            return nextLang;
        });
    };

    const value = {
        language,
        toggleLanguage
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}; 